import { Component, OnInit, Input, Injectable, Inject } from '@angular/core';
import { BaseService } from './../../../_services/base.service';
import { Observable } from 'rxjs/Rx';
import { BaseEndpoint } from './../../../app.constants';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-modal',
  templateUrl: './modal-pdf.component.html',
  styleUrls: ['./modal-pdf.component.scss']
})
export class ModalPdfComponent implements OnInit {
  @Input() data: any;
  item: any;
  pdfSrc: any;
  loading: boolean = true;
  title: string;
  nameArray: any;
  container: any;
  constructor(private baseService: BaseService, @Inject(BaseEndpoint) private baseApiEndpoint, ) { }

  ngOnInit() {
    this.item = this.data;
    switch (this.data.processMapId) {
      case 1: {
        this.container = "refining";
        break;
      }
      case 2: {
        this.container = "petrochemical";
        break;
      }
      case 3: {
        this.container = "additives";
        break;
      }
      default: {
        this.container = "refining";
        break;
      }
    }
    this.pdfSrc = this.baseApiEndpoint + '/api/GetBlob/' + this.container + '/' + this.data.longDescription;
    this.nameArray = this.data.longDescription.match(/[A-Z][a-z]+/g);
    this.title = this.nameArray.join(' ');
  }
  loadComplete(pdf: PDFDocumentProxy) {
    this.loading = false;
  }
  onError(error: any) {
    alert("There was an error loading the pdf");
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/components/shared/modal-pdf/modal-pdf.component.ts